import EverTrue from 'app';
import BaseRouter from 'base/base-router';
import IsFlaggedController from 'components/flags/is-flagged-controller';
import PhoneController from './phone-controller';

class PhoneRouter extends BaseRouter {
  static initClass() {
    this.prototype.routes = {
      'outreach/phone': 'phone',
    };
  }

  phone() {
    EverTrue.execute('setBrowserTitle', 'Outreach');
    this.currentView = (
      <IsFlaggedController flag="signal">
        <PhoneController />
      </IsFlaggedController>
    );
    EverTrue.page.mount(this.currentView);
  }
}

PhoneRouter.initClass();
export default PhoneRouter;
